var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 441,
    height: 441,
    viewBox: "0 0 441 441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "result-placeholder",
    transform: "translate(-634 -212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22",
    "data-name": "Groupe 22",
    transform: "translate(445 89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    transform: "translate(189 123)",
    fill: "#fff",
    stroke: "#717f94",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0H221a0,0,0,0,1,0,0V221a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,.5H220a.5.5,0,0,1,.5.5V220a.5.5,0,0,1-.5.5H1a.5.5,0,0,1-.5-.5V10A9.5,9.5,0,0,1,10,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    transform: "translate(189 343)",
    fill: "#fff",
    stroke: "#717f94",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H221a0,0,0,0,1,0,0V221a0,0,0,0,1,0,0H10A10,10,0,0,1,0,211V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,.5H220a.5.5,0,0,1,.5.5V220a.5.5,0,0,1-.5.5H10A9.5,9.5,0,0,1,.5,211V1A.5.5,0,0,1,1,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    transform: "translate(409 123)",
    fill: "#fff",
    stroke: "#717f94",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H211a10,10,0,0,1,10,10V221a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,.5H211a9.5,9.5,0,0,1,9.5,9.5V220a.5.5,0,0,1-.5.5H1a.5.5,0,0,1-.5-.5V1A.5.5,0,0,1,1,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    transform: "translate(409 343)",
    fill: "#fff",
    stroke: "#717f94",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H221a0,0,0,0,1,0,0V211a10,10,0,0,1-10,10H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,.5H220a.5.5,0,0,1,.5.5V211a9.5,9.5,0,0,1-9.5,9.5H1a.5.5,0,0,1-.5-.5V1A.5.5,0,0,1,1,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 95,
    height: 95,
    rx: 47.5,
    transform: "translate(252 186)",
    fill: "rgba(113,127,148,0.2)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(294.247 241.635)",
    fill: "#717f94",
    fontSize: 27,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 95,
    height: 95,
    rx: 35,
    transform: "translate(472 186)",
    fill: "rgba(113,127,148,0.2)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(510.055 241.635)",
    fill: "#717f94",
    fontSize: 27,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_33",
    "data-name": "Groupe 33",
    transform: "translate(232.288 386.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 94.693,
    height: 94.693,
    rx: 35,
    transform: "translate(0 66.958) rotate(-45)",
    fill: "rgba(113,127,148,0.2)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(58.391 76.118)",
    fill: "#717f94",
    fontSize: 28,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_6",
    "data-name": "Polygone 6",
    d: "M42.4,39.114a26,26,0,0,1,45.06,0l19.952,34.639a26,26,0,0,1-22.53,38.977h-39.9a26,26,0,0,1-22.53-38.977Z",
    transform: "translate(454.592 378.672)",
    fill: "rgba(113,127,148,0.2)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(508.555 463)",
    fill: "#717f94",
    fontSize: 27,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.37ea967519d74bb54940ba5ec5a68e80.svg";
export { ForwardRef as ReactComponent };